import React from 'react';
import ReactDOM from 'react-dom/client';
import './output.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './Chatbot/State/store/store';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';


const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp=()=>{

  root.render(
    <React.StrictMode>

      <Provider store = {store}>

      <App />
      </Provider>
     
    </React.StrictMode>
  );

}

store .subscribe((state)=>{
  renderApp()

console.log(store.getState(),'subscribed')


})

renderApp()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
